import React from "react";

import TooltipButton from "../TooltipButton";
import { IBulkHashSearchBtn } from "../@types";
import { SEARCH_MODALS_NAMES } from "../../../search/hooks/useSearchModals";

export const BulkHashSearchBtn = ({ onClick }: IBulkHashSearchBtn) => (
  <TooltipButton
    onClick={() => onClick({ type: SEARCH_MODALS_NAMES.BULK_SEARCH })}
    label="Bulk hash search"
    type="bulk-search"
  />
);
